import {gql} from '@apollo/client';
import {withQuery} from '../../hooks/withWrap';

export const GET_SHIP_BOX_LIST = gql`
query GetShipBoxList {
  shipBoxList {
    shipBoxId
    shipName
    shipExtra
    shipDate 
    createdBy
  }
}
`;

export const GET_SHIP_BOX_DETAILS = gql`
query GetShipBox($shipBoxId: ID!) {
  shipBoxDetail(shipBoxId: $shipBoxId) {
    shipBoxId
    shipName
    shipExtra
    shipDate 
    shipItems {
      shipItemId
      item
    }
    shipRuns {
      shipRunId
      insertedAt
    }
    createdBy
  }
}
`;

export const CREATE_SHIP_BOX = gql`
  mutation($shipBoxIn: ShipBoxIn!) {
    createShipBox(shipBoxIn: $shipBoxIn) {
      shipBoxId
    }
  }
`;

export const RUN_SHIP_BOX = gql`
  mutation($shipBoxId: ID!) {
    runShipBox(shipBoxId: $shipBoxId) {
      shipRunId
    }
  }
`;

export const DELETE_SHIP_BOX = gql`
  mutation($shipBoxId: ID!) {
    deleteShipBox(shipBoxId: $shipBoxId) {
      shipBoxId
    }
  }
`;

export const CREATE_SHIP_ITEM = gql`
  mutation($shipBoxId: ID!, $eanIn: String!) {
    createShipItem(shipBoxId: $shipBoxId, eanIn: $eanIn) {
      shipItemId
    }
  }
`;

export const DELETE_SHIP_ITEM = gql`
  mutation($shipItemId: ID!) {
    deleteShipItem(shipItemId: $shipItemId) {
      shipItemId
    }
  }
`;

export const GET_SHIP_RUN_DETAILS = gql`
  query GetShipRun($shipRunId: ID!) {
    shipRunDetail(shipRunId: $shipRunId) {
      shipRunId
      insertedAt
      shipShipments {
        shipmentNumber
      }
    }
  }
`;

export function shipBoxListQuery(component, props) {
  return withQuery(component, GET_SHIP_BOX_LIST)(props);
}
